import bookCatalog from './bookCatalog'
import bookReading from './bookReading'
import challenge from './challenge'
import dashboard from './dashboard'
import home from './home'
import initialTour from './initialTour'
import navigation from './navigation'
import profile from './profile'
import library from './library'
import ranking from './ranking'
import store from './store'
import dictionary from './dictionary'

export default {
    loggedOut: "There's no active session",
    points: 'Points',
    avatars: 'Avatars',
    categories: 'Categories',
    save: 'Save',
    title_dashboard: 'Home | Beereaders',
    title_bookReading: 'Reading Experience | Beereaders',
    title_book_catalog: 'Book catalog | Beereaders',
    title_messages: 'Messages | Beereaders',
    title_library: 'Library | Beereaders',
    title_challenges: 'Challenges | Beereaders',
    title_ranking: 'Ranking | Beereaders',
    title_profile: 'Profile | Beereaders',
    title_store: 'Store | Beereaders',
    index: 'Home',
    challenges: 'Challenges',
    messages: 'Messages',
    books: 'Books',
    select_avatar: 'Select Avatar and Categories',
    logout: 'Logout',
    menu_mission: 'Missions and Achievements',
    your_level: 'Your Level',
    experience_points: 'Experience Points',
    beeCoins: 'BeeCoins',
    level: 'Level',
    read: 'Read',
    unknown: 'Unknown',
    msg_error: 'Uy!',
    msg_warning: 'Warning!',
    msg_info: 'Information!',
    msg_success: 'Oh Yes!',
    msg_load_error: 'Error loading content',
    txt_load_error: 'Click the accept button to reload the page and try again',
    general_error_message: 'An error has ocurred, try again later',
    anonymous: 'Anonymous',
    button_yes: 'Yes',
    button_no: 'No',
    button_close: 'Close',
    button_accept: 'To accept',
    go_back: 'Go back',
    questions: 'Questions',
    nextQuestion: 'Next Question',
    nextText: 'Next Text',
    company_name: 'Beereaders',
    slogan: '8 years of experience in educational technology.',
    your_messages: 'Your Messages',
    from: 'From:',
    comments: 'Comments',
    no_comment: 'There are not Comments',
    more_nine_comments: '+9 Comments',
    of: 'of',
    true: 'Verdadero',
    false: 'Falso',
    beecoins: 'Beecoins',
    about: 'About',
    greet: '¡Hola',
    greet_msg: 'I hope you are well on this wonderful day',
    exit: 'Exit',
    download_app_message: 'Download our application to enter',
    challenge_not_exists: 'The challenge you are trying to find does not exist.',
    bookCatalog,
    bookReading,
    challenge,
    dashboard,
    home,
    initialTour,
    navigation,
    profile,
    library,
    ranking,
    store,
    dictionary
}
